






import { defineComponent, reactive, toRefs, onMounted } from '@vue/composition-api';
import AlertArea from "../../components/AlertArea.vue";
import http from "../../plugins/http";

export interface Data {
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    /******************************
      * data
      ******************************/

    const state = reactive<Data>({
      errors: new Array<string>(),
    });

    /******************************
      * mounted
      ******************************/
    
    onMounted(async () => {

      context.root.$store.dispatch("showOverlay");
      
      await http.post(`/api/login/teacher_from_sso`, {token: context.root.$route.query.token}).then(response => {
        
        // @ts-ignore
        context.root.$store.commit("setBase64SchoolLogo", require("@/assets/images/logo_smarky_ol.png"));
        
        var user = response.data.user;

        // トークン設定
        var token = user.access_token
        document.cookie = `access_token=${token}`;
        document.cookie = 'smarky_user_id=' + user.id;
        document.cookie = "api_kind=sso_teacher_login";
        context.root.$store.commit("setCurrentUser", user);
        context.root.$store.commit("setViewPoints", response.data.view_points);
        context.root.$store.commit("setIsSSO", true);

        context.root.$router.push(`/teacher_site/sheet_list`).catch(err => {});
        context.root.$store.commit("setIsHeaderDisp", true);
      })
      .catch(error=>{
        // エラーの場合はアラートを表示してウィンドウを閉じる
        if(error.response.data && error.response.data.errors && error.response.status == 422){
          alert(`${error.response.data.errors[0]}ブラウザを終了します。`);
        }else{
          alert("認証に失敗しました。ブラウザを終了します。");
        }
        window.close();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
    }
  }
})
